module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Gross price":"Brutto-Preis","Net price":"Netto-Preis","Tax rate":"Steuersatz","Regular":"Regulär","Reduced":"Vermindert","Type":"Art","Sale date range":"Angebotszeitraum","Starts At":"Beginnt am","Ends At":"Endet am","min. Quantity":"min. Bestellmenge","pcs.":"stk.","Customer group":"Kundengruppe","Customer group price":"Kundengruppenpreis","Inherit":"Wie Produkt"}}')
  delete Component.options._Ctor
}
